import React, { Component } from 'react';
import { Screen } from 'dooh-react-utils';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 1080px;
  height: 1920px;
  box-sizing: border-box;
  padding: 95px 0 0 130px;
`

const H1 = styled.div`
  width: 778px;
  color: white;
  font-size: 216px;
  font-family: "zabaBold";
  line-height: 88%;
`;

const H2 = styled.div`
  width: 816px;
  padding-top: 88px;
  color: white;
  font-size: 93px;
  font-family: "zabaRegular";
  line-height: 102%;
`;

export default class ThanksScreen extends Component {
  render() {
    return (
      <Screen>
        <Wrapper>
          <H1>Hvala na<br/>prijavi!</H1>
          <H2>Do 31.7.2017. Zaba će
              <br/>ti javiti jesi li osvojio
              <br/>nagradu.
          </H2>
        </Wrapper>
      </Screen>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/ThanksScreen.js